import { createContext } from 'react';

const subcuentasContext = createContext();

export default subcuentasContext;